import {
    UPDATE_FEE_MARKUP_SUCCESS,
    UPDATE_FEE_MARKUP_FAILED,
    RESET_UPDATE_FEE_MARKUP,
    LOADING_UPDATE_FEE_MARKUP,
    NETWORK_ERROR_UPDATE_FEE_MARKUP,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateFeeMarkup = () => {
    return { type: RESET_UPDATE_FEE_MARKUP };
};

const updateFeeMarkup =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_UPDATE_FEE_MARKUP });
        await partnerServices
            .post("updateMarkupList", userData, {
                headers: { AuthToken: authTokenIs },
            })
            .then((res) => {
                switch (res.status) {
                    case 200:
                        dispatch(updateFeeMarkupSuccess(res.data));
                        break;
                    default:
                        dispatch(updateFeeMarkupFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_UPDATE_FEE_MARKUP,
                    payload: err,
                });
            });
    };

function updateFeeMarkupSuccess(data) {
    return {
        type: UPDATE_FEE_MARKUP_SUCCESS,
        payload: data,
    };
}

function updateFeeMarkupFailed(data) {
    return {
        type: UPDATE_FEE_MARKUP_FAILED,
        payload: data,
    };
}

export {
    resetUpdateFeeMarkup,
    updateFeeMarkup,
};